export const ENTERPRISE_ONBOARDING_FORM = "ENTERPRISE_ONBOARDING_FORM";
